module.exports = __webpack_public_path__ + "img/Popup_Akteure4.1b2f7388.png";